module.exports = __webpack_public_path__ + "static/img/collected.cfc7b756.png";